// extracted by mini-css-extract-plugin
module.exports = {"moveModal":"MoveModal-modulemoveModal3a2"};